/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

$(document).ready(function () {
  openPopupCookies();
  initPopupVideo();
  initHoverMegaMenuCountry();
  getMetafieldsAvailableFromProduct();
  hideTaxesLabelonCh();
});



// PLAYER VIDEO--------------------------------------
if ($('#hero-video').length > 0) { var player = videojs('hero-video'); }

// MENU' MOBILE--------------------------------------

$(window).on("resize", function (e) {
  var Finestra = $(window).width();

  if (Finestra >= 885) {
    $(".menu-mobile-wrapper").hide();

    if ($("#mobile-menu").hasClass("icon--close")) {
      $("#mobile-menu").removeClass("icon--close").addClass("icon--menu");
    }
  }
});

// Funzione per aprire il menù

$(".menu-hamburger").on("click", function (e) {
  if ($(".menu-mobile-wrapper").is(":hidden")) {
    $(".menu-mobile-wrapper").fadeIn();
  } else {
    $(".menu-mobile-wrapper").slideUp();
  }

  if ($("#mobile-menu").hasClass("icon--menu")) {
    $("#mobile-menu").removeClass("icon--menu").addClass("icon--close");
  } else if ($("#mobile-menu").hasClass("icon--close")) {
    $("#mobile-menu").removeClass("icon--close").addClass("icon--menu");
  }
});

// Funzione per lo slideup/down del sub_menù

$(".mobile_nav__link--first").on("click", function (e) {
  var FirstLink = $(this).siblings().find(".mobile--sub_link");

  if (FirstLink.is(":hidden")) {
    FirstLink.slideDown();
  } else {
    FirstLink.slideUp();
  }
});

// Funzione per lo slideup/down del sub__sub_menù

$(".mobile_nav__link--second").on("click", function (e) {
  var subSubMenu = $(this).siblings().find(".mobile--sub_sub_link");
  var checkLink = subSubMenu.next().hasClass("haslink");

  if (subSubMenu.is(":hidden")) {
    subSubMenu.slideDown();
  } else if (subSubMenu.is(":visible") && checkLink == true) {
    // subSubMenu.slideUp();
  } else if (subSubMenu.is(":visible") && checkLink == false) {
    subSubMenu.slideUp();
  }
});

// Funzione per lo slideup/down del sub_menù countries

$(".mobile_nav__link-country").on("click", function (e) {
  var countryLinks = $(this).siblings().find(".mobile--sub_link-country");

  if (countryLinks.is(":visible")) {
    countryLinks.slideUp();
  } else {
    countryLinks.slideDown();
  }
});

// DIV HEADER LINGUE-----------------------------------

function initHoverMegaMenuCountry() {
  var itemMenuCountryList = $('.item-menu-country-list');
  var countryDiv = $(".country-val");

  itemMenuCountryList.hover(
    function() {
      if (countryDiv.is(":hidden")) {
        countryDiv.fadeIn().css("display", "flex");
      } else {
        countryDiv.fadeOut();
      }
    }, function() {
      countryDiv.fadeOut();
    }
  );
}

function hideTaxesLabelonCh() {
  if (localStorage.getItem('gdprCache')) {
    var data = localStorage.getItem('gdprCache');
    var parseData = JSON.parse(data);
    var countryData = JSON.parse(parseData.countryDetection);
    var country = countryData.country;
    if (country !== 'CH' && window.shopId === 50869502128) $('body').addClass('hide-taxes-label');
  }
}

/*
$(".valute-stores").on("click", function (e) {
  var CountryDiv = $(".country-val");

  if (CountryDiv.is(":hidden")) {
    CountryDiv.fadeIn().css("display", "flex");
  } else {
    CountryDiv.fadeOut();
  }
});
*/


$(".valutes").on("click", function (e) {
  if ($(".counties-mobile").is(":hidden")) {
    $(".counties-mobile").slideDown();
  } else {
    $(".counties-mobile").slideUp();
  }
});

function getMetafieldsAvailableFromProduct() {
  var selectSize = $(".select-size");
  if (selectSize.length <= 0) {
    return;
  }
  var optionTextSelected = $(".select-size option:selected").data(
    "availabletext"
  );
  if (
    optionTextSelected != "null" &&
    optionTextSelected != null &&
    optionTextSelected != undefined &&
    optionTextSelected != "undefined"
  ) {
    $("#available-from-label").text(optionTextSelected);
    $(".js-product-add-text").text("PRE-ORDER");
  }
}

function openPopupCookies() {
  var link = $('.link_open_popup_cookies');
  if (link.length <= 0) {
    return;
  }
  link.on('click', function () {
    document.querySelector('.cc-settings').click();
  });
}


function initPopupVideo() {

  // Variables
  var videoPageWrapper = $('#shopify-section-44-video-page'),
      videoIframe = $('#44-video-page iframe'),
  linkToSite = $('#link-to-site'),
      html = $('html'),
      body = $('body'),
      playerVideo = $('#player_video_popup'),
      linkShowVideo = $('.link_show_video'),
  hiddenClass = 'disable-scroll-page'

  // Show splash page or video page
  if($('#ctb_placeholder')) {
    toggleHpVideo()
    $("#44-video-page, #ctb_placeholder").css({'display': 'none','opacity':'0'});
    const now = Date.now();
    let end_date = $('#ctb_placeholder').attr('data-custom-end-date');
    if(!end_date) { // Fallback - Date in the past
      end_date = 'Jan 01, 2021 00:00';
    }
    const then = new Date(end_date).getTime();
    if (then > now) { // countdown date is in the future, show countdown
      $("#ctb_placeholder").css({'display': 'block','opacity':'1'});
      let countDown;
      countDown = setInterval(() => {
        const secondsLeft = Math.round((then - Date.now()) / 1000);
        if(secondsLeft < 0) {
          $("#ctb_placeholder").css({'display': 'none','opacity':'0'});
          $("#44-video-page").css({'display': 'block','opacity':'1'});
          clearInterval(countDown);
          return;
        }
      }, 1000);
    } else {
      $("#44-video-page").css({'display': 'block','opacity':'1'});
    }
    $( document ).on( 'click', '#link-to-site-splash', function(e) {
      $('#shopify-section-44-video-page').fadeOut();
      html.removeClass(hiddenClass);
      body.removeClass(hiddenClass);
    });

    if($('body > #shopify-section-44-video-page' ).length > 0) {
      html.addClass(hiddenClass);
      body.addClass(hiddenClass);
    }
  }

  // Istanza video player
  //var player = plyr.setup('#player_video_popup');
  // Controllo se visualizzare la pagina col video
  var showVideoPageForParade = showVideoPage(videoPageWrapper);

  // Show popup video page
  videoPageWrapper.show();

  // Video gia visualizzato
  if (!showVideoPageForParade) {
    videoPageWrapper.hide();
    html.removeClass(hiddenClass);
    body.removeClass(hiddenClass);
    // Video ancora non visualizzato
  } else {
    // Stop scrolling when video page is visible
    html.addClass(hiddenClass);
    body.addClass(hiddenClass);
  }

  // Close video page
  linkToSite.on('click', function () {
    if (player) {
      player[0].pause();
    } else if (videoIframe && videoIframe.length > 0) {
      videoIframe.attr('src', '')
    }

    videoPageWrapper.hide();
    html.removeClass(hiddenClass);
    body.removeClass(hiddenClass);
  });

  // Reopen video page
  linkShowVideo.on('click', function () {
    // Stop scrolling when video page is visible
    html.addClass(hiddenClass);
    body.addClass(hiddenClass);
    // Show popup video
    videoPageWrapper.show();
  });
}

function toggleHpVideo() {
  const video = $('#bg-video')
  const videoSource = video.find('source')
  const mobileVideo = video.data('mobile')
  const desktopVideo = video.data('desktop')
  videoSource.remove()
  if ($(window).width() <= 768) {
    video.append("<source src='"+mobileVideo+"' type='video/mp4' >");
  } else {
    video.append("<source src='"+desktopVideo+"' type='video/mp4' >");
  }
}

function showVideoPage (videoPageWrapper) {
  if ($('body').hasClass('template-index') && videoPageWrapper.length > 0) {
    return true;
  }
  return false;
}

// document.addEventListener("DOMContentLoaded", () => {
//   const utmParams = UtmUrlSearch();
//
//   if (utmParams) {
//
//     const newUrl = window.location.origin + window.location.pathname + '?' + utmParams + window.location.hash;
//     window.history.replaceState({}, document.title, newUrl);
//
//
//     document.querySelectorAll("a[href^='/'], a[href^='" + window.location.origin + "']").forEach(link => {
//       const url = new URL(link.href);
//       url.search = utmParams;
//       link.href = url.toString();
//     });
//   }
// });
//
//
// function UtmUrlSearch() {
//   const urlParams = new URLSearchParams(window.location.search);
//   const utmParams = new URLSearchParams();
//   for (const [key, value] of urlParams.entries()) {
//     if (key.startsWith('utm_')) {
//       utmParams.set(key, value);
//     }
//   }
//   if (utmParams) {
//     return utmParams.toString();
//   } else {
//     return "";
//   }
// }
